<template>
	<div class="operation">
		<Header />
		<Banner :src="src" />
		<!-- operation_banner -->
		<div class="operation_c m" v-html="text">
		</div>
		<Footer />
		<!-- 底部 -->
	</div>
</template>

<script>
import Footer from '../../components/Footer.vue'
import Banner from '../../components/Banner.vue'
import Header from '../../components/Header.vue'
import Axios from 'axios'
const Base64=require('js-base64')
export default {
	components: { Header,Banner, Footer },
	data() {
		return {
			src:'',
			text:'',
			str:''
		}
	},
	mounted(){
		Axios({
				url: '/apiv2/sconfig/getlist',
				data: {},
				method: 'GET',
			}).then((res) => {
				for(var i=0;i<res.data.data.rows.length;i++){
					if(res.data.data.rows[i].sc_key.slice(0,10)=="OPS_BANNER"){
						this.src=res.data.data.rows[i].sc_value
					}
					if(res.data.data.rows[i].sc_key.slice(0,8)=='OPS_TEXT'){
						this.text=Base64.decode(res.data.data.rows[i].sc_value).replaceAll("<a","<a rel='noopener noreferrer'")
					}
				}
			})
	}
}
</script>

<style lang="scss" scoped>
::v-deep font{
	line-height: 40px;
}
::v-deep span{
	line-height: 40px;
}
::v-deep p{
	line-height: 40px;
}
@media (min-width: 1200px) {
	@import '../../style/base.scss';
	@import './index.scss';
}
@media (max-width: 1199px) {
	@import '../../style/mb.scss';
	@import './m-index.scss';
}
</style>